<template>
	<section style="overflow-y: auto;height: calc(100vh - 110px);">
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-form :inline="true" :model="filters" class="filterForm">
				<el-form-item label="排位赛名称:" label-width="100px">
					<el-input v-model="filters.matchName" auto-complete="off" class="formItem" size="small" />
				</el-form-item>
				<el-form-item label="所属年级:" label-width="110px">
					<el-select v-model="filters.gradeId" placeholder="请选择" size="small" class="formItem250" clearable>
						<el-option v-for="item in gradeDict" :key="item.id" :label="item.gradeName" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="教材版本:" label-width="110px">
					<el-select v-model="filters.bookVersionId" placeholder="请选择" size="small" class="formItem250" clearable>
						<el-option v-for="item in bookVersionDict" :key="item.valuekey" :label="item.textkey"
							:value="item.valuekey">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="赛季:" label-width="110px">
						<el-select v-model="filters.seasonId" placeholder="请选择" size="small" class="formItem250" clearable>
							<el-option v-for="item in seasonDict" :key="item.id" :label="item.seasonName"
								:value="item.id">
							</el-option>
						</el-select>
			</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getGridData" size="small">查询</el-button>
					<el-button type="primary" @click="addInfo" size="small">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="grid_data" height="calc(100vh - 200px)" border highlight-current-row v-loading="listLoading"
			@selection-change="(v) => { sels = v }" style="width: 100%;">
						<el-table-column prop="seasonName" label="赛季" width="150"></el-table-column>
			<el-table-column prop="matchName" label="排位赛名称" width="200" show-overflow-tooltip></el-table-column>
			<el-table-column prop="scoreNum" label="总分数" width="80"></el-table-column>
			<el-table-column prop="startDate" label="开始日期" width="100" :formatter="$util.dateFormat"></el-table-column>
			<el-table-column prop="endDate" label="结束日期" width="100" :formatter="$util.dateFormat"></el-table-column>
			<el-table-column prop="gradeName" label="所属年级" width="80"></el-table-column>
			<el-table-column prop="bookVersionName" label="教材版本" width="80"></el-table-column>

			<el-table-column prop="joinCount" label="参赛人数" width="80">
				<template scope="scope">
					<span v-html="showJoinCount(scope.row)" @click="handleJoinUser(scope.row)"></span>
				</template>
			</el-table-column>
			<el-table-column prop="count" label="题目条数" width="80"></el-table-column>
			<el-table-column prop="status" label="状态" width="75"
				:formatter="(v) => { return v.status == 0 ? '停用' : '正常' }"></el-table-column>
			<el-table-column prop="matchRemark" label="描述" width="150" show-overflow-tooltip></el-table-column>
			<el-table-column label="操作" min-width="160">
				<template scope="scope">
					<el-button size="small" @click="editInfo(scope.$index, scope.row)">编辑</el-button>
					<el-button size="small" @click="delInfo(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!--分页-->
		<pagination :totalPage="total" :currentPage="filters.page" :pageSize="filters.rows"
			@pageSizeCallBack="handleSizeChange" @currentPageCallBack="handleCurrentChange"></pagination>
		<addsave :showTitle="showTitle" ref="refAdd" :dialogAddShow="dialogAddShow" :mid="mid"
			@saveCallBack="saveCallBack" @addExercise="addExercise" @getVisible="(v) => { dialogAddShow = v }">
		</addsave>
		<addsave2 :showTitle="showTitle2" :mid="Number('0')" :dialogAddShow="dialogAddShow2"
			@saveCallBack="saveCallBack2" @getVisible="(v) => { dialogAddShow2 = v }"></addsave2>
		<addsave3 showTitle="查看参数用户" :mid="mid3" :dialogAddShow="dialogAddShow3"
			@getVisible="(v) => { dialogAddShow3 = v }">
		</addsave3>
	</section>
</template>
<script>
import pagination from '@/components/common/pagination.vue'
import addsave from './rankmatchadd.vue'
import addsave2 from './exerciseinfoadd.vue'
import addsave3 from './rankmatchuserlist.vue'
export default {
	components: { addsave, pagination, addsave2, addsave3 },
	data() {
		return {
			filters: {
				matchName: '',
				gradeId:'',
				bookVersionId:'',
				seasonId:'',
				status: 0,
				rows: 10,
				page: 1
			},
			grid_data: [],
			total: 0,
			listLoading: false,
			sels: [],//列表选中列
			showTitle: "",
			dialogAddShow: false,
			mid: 0,
			dialogAddShow2: false,
			showTitle2: '新增题目',
			dialogAddShow3: false,
			mid3: 0,
			bookVersionDict:[],
			gradeDict:[],
			seasonDict:[]
		}
	},
	methods: {
		showJoinCount(row) {
			if (Number(row.joinCount) > 0) {
				return "<font color='blue'>" + row.joinCount + "</font>"
			}
			else {
				return row.joinCount
			}
		},
		handleJoinUser(row) {
			this.dialogAddShow3 = true
			this.mid3 = row.id
		},
		async loadSeason() {
			let formData = this.$util.jsonToForm({
				seasonName: '',
				rows: 1000,
				page: 1
			});
			this.$axios.post("/exercise/getrankmatchseasonlist", formData).then(res => {
				this.seasonDict = res.data.data;
			});
		},
		//获取列表
		getGridData() {
			this.listLoading = true;
			let formData = this.$util.jsonToForm(this.filters);
			this.$axios.post("/exercise/getrankmatchlist", formData).then(res => {
				this.listLoading = false;
				this.total = res.data.total;
				this.grid_data = res.data.data;
			});
		},
		//删除
		delInfo: function (index, row) {
			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning'
			}).then(() => {
				let formData = new FormData();
				formData.append("id", row.id);
				this.$axios.post("/exercise/rankmatchdel", formData).then(res => {
					if (res.data.status == 0) {
						this.$message("删除成功!");
						this.getGridData();
					} else {
						this.$message(res.data.msg);
					}
				});
			});
		},
		//disabledInfo
		addInfo: function () {
			this.showTitle = "新增排位赛";
			this.dialogAddShow = true;
			this.mid = 0;
		},
		editInfo: function (index, row) {
			this.showTitle = "编辑排位赛";
			this.dialogAddShow = true;
			this.mid = row.id;
		},
		saveCallBack: function () {
			this.dialogAddShow = false;
			if (this.mid == 0) {
				this.handleCurrentChange(1);
			}
			else {
				this.getGridData();
			}
		},
		addExercise: function (v) {
			this.dialogAddShow2 = v
		},
		saveCallBack2(id) {
			this.dialogAddShow2 = false
			this.$refs.refAdd.saveCallBack(id)
		}
	},
	async created() {
		this.gradeDict=await this.loadGrade()
			await this.loadSeason()
		this.bookVersionDict = (await this.getDictInfo('bookVersion'))
		this.getGridData();
	}
}

</script>

<style scoped></style>
